/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'base-bschool': {
    width: 15.825,
    height: 16,
    viewBox: '0 0 15.825 16',
    data: '<path pid="0" d="M15.251 14.88h-.575v-6.2a.576.576 0 00-.575-.575H12.38v6.807h-.429V5.86a.576.576 0 00-.575-.575H6.722V4.022h3.848a.409.409 0 00.2-.058.324.324 0 00.058-.459L9.767 2.1 10.801.689a.547.547 0 00.058-.2.319.319 0 00-.316-.316H6.608A1.054 1.054 0 006.32 0a.485.485 0 00-.489.489v4.768H4.423a.576.576 0 00-.575.575v9.019h-.397V8.073H1.696a.576.576 0 00-.575.575v6.232H.546a.564.564 0 00-.545.545.553.553 0 00.545.575H15.28a.56.56 0 00-.028-1.12zm-8.266-1.019a.66.66 0 01-1.319 0V7.843a.66.66 0 011.319 0v6.018zm2.784 0a.66.66 0 01-1.319 0V7.843a.66.66 0 011.319 0v6.018z" _fill="#212121"/>'
  }
})
